import { useState } from 'react';
import useConstant from 'use-constant';
import { useAsync, UseAsyncReturn } from 'react-async-hook';
import AwesomeDebouncePromise from 'awesome-debounce-promise';

// Generic reusable hook
export const useDebouncedSearch = (searchFunction: (arg: any) => any) => {
  const [inputText, setInputText] = useState('');

  // Debounce the original search async function
  const debouncedSearchFunction = useConstant(() =>
    AwesomeDebouncePromise(searchFunction, 1000),
  );

  // The async callback is run each time the text changes,
  // but as the search function is debounced, it does not
  // fire a new request on each keystroke
  const searchResults = useAsync(async () => {
    if (inputText.length === 0) {
      return [];
    }
    return debouncedSearchFunction(inputText);
  }, [debouncedSearchFunction, inputText]);

  // Return everything needed for the hook consumer
  return [inputText, setInputText, searchResults] as [
    any,
    any,
    UseAsyncReturn<any, (string | ((arg: any) => any))[]>,
  ];
};
